/**
 * When a Contents filter lists both disc and cartridge wording, show one Game row.
 * Disc Only + Cartridge Only become Game Only, and the matching completeness pairs follow.
 */
(function () {
  var GROUPS = [
    {
      id: 'loose',
      label: 'Game Only',
      labels: ['disc only', 'cartridge only'],
    },
    {
      id: 'inbox',
      label: 'Game, Case, and Art',
      labels: ['disc, case, and art', 'cartridge, case, and art', 'cartridge, box, and art'],
    },
    {
      id: 'cib',
      label: 'Game, Case, Art, and Manual',
      labels: [
        'disc, case, art, and manual',
        'cartridge, case, art, and manual',
        'cartridge, box, art, and manual',
      ],
    },
  ];

  function labelOf(li) {
    return (li.getAttribute('data-ri-facet-label') || '').trim().toLowerCase();
  }

  function isContents(facet) {
    var heading = facet.querySelector('.ri-facet__label');
    return !!(heading && /content/i.test(heading.textContent || ''));
  }

  function stripValues(href, labels) {
    var url = new URL(href, window.location.origin);
    var drop = {};
    labels.forEach(function (label) {
      drop[label.toLowerCase()] = true;
    });
    var next = new URLSearchParams();
    url.searchParams.forEach(function (value, key) {
      if (!drop[String(value).toLowerCase()]) next.append(key, value);
    });
    var query = next.toString();
    return url.pathname + (query ? '?' + query : '');
  }

  function mergeList(facet) {
    var items = Array.prototype.slice.call(facet.querySelectorAll('li[data-ri-facet-label]'));
    if (!items.length) return;
    var hasDisc = items.some(function (li) {
      return labelOf(li).indexOf('disc') !== -1;
    });
    var hasCart = items.some(function (li) {
      return labelOf(li).indexOf('cartridge') !== -1;
    });
    if (!hasDisc || !hasCart) return;

    GROUPS.forEach(function (group) {
      var members = items.filter(function (li) {
        return group.labels.indexOf(labelOf(li)) !== -1 && !li.hasAttribute('data-ri-merge-hidden');
      });
      var hasGroupDisc = members.some(function (li) {
        return labelOf(li).indexOf('disc') !== -1;
      });
      var hasGroupCart = members.some(function (li) {
        return labelOf(li).indexOf('cartridge') !== -1;
      });
      if (!hasGroupDisc || !hasGroupCart) return;

      var lead = members[0];
      var leadInput = lead.querySelector('input[type="checkbox"]');
      var label = lead.querySelector('label');
      if (!leadInput || !label || lead.querySelector('[data-ri-merge-toggle]')) return;

      var anyChecked = members.some(function (li) {
        var input = li.querySelector('input[type="checkbox"]');
        return input && input.checked;
      });
      var allDisabled = members.every(function (li) {
        var input = li.querySelector('input[type="checkbox"]');
        return input && input.disabled;
      });

      var toggle = document.createElement('input');
      toggle.type = 'checkbox';
      toggle.className = leadInput.className;
      toggle.id = leadInput.id;
      toggle.checked = anyChecked;
      toggle.disabled = allDisabled && !anyChecked;
      toggle.setAttribute('data-ri-merge-toggle', group.id);

      leadInput.id = leadInput.id + '-src';
      leadInput.setAttribute('data-ri-merge-member', group.id);
      leadInput.classList.add('ri-facet-merge-input');
      leadInput.tabIndex = -1;
      label.setAttribute('for', toggle.id);
      label.insertBefore(toggle, leadInput);

      var nameEl = lead.querySelector('.facet-checkbox__text-label');
      var shown = lead.querySelector('.facet-checkbox__text-shown');
      if (nameEl) nameEl.setAttribute('data-label', group.label);
      if (shown) {
        var textNode = null;
        for (var c = 0; c < shown.childNodes.length; c++) {
          if (shown.childNodes[c].nodeType === 3) {
            textNode = shown.childNodes[c];
            break;
          }
        }
        if (textNode) textNode.textContent = group.label;
        else shown.insertBefore(document.createTextNode(group.label), shown.firstChild);
      } else if (nameEl) {
        nameEl.textContent = group.label;
      }
      var count = 0;
      members.forEach(function (li) {
        var countEl = li.querySelector('.ri-facet__count');
        var n = countEl ? parseInt(String(countEl.textContent).replace(/[^\d]/g, ''), 10) : 0;
        if (!isNaN(n)) count += n;
      });
      var countEl = lead.querySelector('.ri-facet__count');
      if (countEl) countEl.textContent = '(' + count + ')';
      var sr = lead.querySelector('.visually-hidden');
      if (sr) sr.textContent = group.label + ' (' + count + ')';
      lead.setAttribute('data-ri-facet-label', group.label.toLowerCase());
      if (anyChecked) label.classList.add('active');

      members.forEach(function (li) {
        var input = li.querySelector('input[type="checkbox"][name]');
        if (input) input.setAttribute('data-ri-merge-member', group.id);
        if (li === lead) return;
        li.setAttribute('data-ri-merge-hidden', group.id);
        li.classList.add('ri-facet-merge-hidden');
      });
    });

    var selected = facet.querySelector('.facets__selected, .ri-facet__selected-count');
    if (selected) {
      var n = 0;
      facet.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
        if (input.hasAttribute('data-ri-merge-member')) return;
        if (input.checked) n += 1;
      });
      selected.textContent = n > 0 ? '(' + n + ')' : '';
      selected.classList.toggle('hidden', n === 0);
    }
  }

  function mergeChips() {
    var chips = Array.prototype.slice.call(document.querySelectorAll('.ri-facets__chip'));
    GROUPS.forEach(function (group) {
      var mine = chips.filter(function (chip) {
        var inner = chip.querySelector('.ri-facets__chip-inner');
        if (!inner) return false;
        var text = '';
        for (var i = 0; i < inner.childNodes.length; i++) {
          if (inner.childNodes[i].nodeType === 3) text += inner.childNodes[i].textContent;
        }
        return group.labels.indexOf(text.trim().toLowerCase()) !== -1;
      });
      if (mine.length < 2) return;
      var keep = mine[0];
      var inner = keep.querySelector('.ri-facets__chip-inner');
      for (var i = 0; i < inner.childNodes.length; i++) {
        if (inner.childNodes[i].nodeType === 3 && inner.childNodes[i].textContent.trim()) {
          inner.childNodes[i].textContent = group.label + ' ';
          break;
        }
      }
      var href = keep.getAttribute('href');
      if (href) keep.setAttribute('href', stripValues(href, group.labels));
      mine.slice(1).forEach(function (chip) {
        var wrap = chip.closest('facet-remove') || chip.parentElement;
        if (wrap && wrap.parentElement) wrap.parentElement.removeChild(wrap);
      });
    });
  }

  function mergeContentsFilters(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.ri-facet').forEach(function (facet) {
      if (!isContents(facet)) return;
      mergeList(facet);
    });
    mergeChips();
  }

  if (!window.__riMergeToggleBound) {
    window.__riMergeToggleBound = true;
    document.addEventListener(
      'change',
      function (event) {
        var toggle = event.target;
        if (!toggle || !toggle.getAttribute || !toggle.getAttribute('data-ri-merge-toggle')) return;
        var facet = toggle.closest('.ri-facet');
        if (!facet) return;
        var id = toggle.getAttribute('data-ri-merge-toggle');
        var members = facet.querySelectorAll('[data-ri-merge-member="' + id + '"]');
        members.forEach(function (input) {
          input.checked = toggle.checked;
          input.disabled = false;
        });
      },
      true
    );
  }

  window.riMergeContentsFilters = mergeContentsFilters;
  mergeContentsFilters(document);
})();
